export const MF_SERVER_KEY = 'ASTRO_MF_SERVER';
export function getServerOverride(mfPath, cookies, env) {
    const overrideValue = cookies.get(MF_SERVER_KEY);
    if (env === 'prod' || !overrideValue) {
        return;
    }
    try {
        for (const mfSource of overrideValue.split(',')) {
            const { origin, pathname } = new URL(mfSource.trim());
            if (pathname === mfPath) {
                return origin;
            }
        }
    }
    catch {
        throw new Error(`Invalid ${MF_SERVER_KEY} value: '${overrideValue}'`);
    }
}
